import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { ChangeEvent, useState, useRef } from 'react';
import { Card, Form } from 'react-bootstrap';
import EmojiPicker from 'components/base/EmojiPicker';
import { useChatContext } from 'providers/ChatProvider';
import ReactTextareaAutosize from 'react-textarea-autosize';
import AttachmentPreview from 'components/common/AttachmentPreview';
import { convertFileToAttachment } from 'helpers/utils';
import ImageAttachmentPreview from 'components/common/ImageAttachmentPreview';
import { faFaceSmile } from '@fortawesome/free-regular-svg-icons';
 
import {
  faImage,
  faPaperPlane,
  faPaperclip,
  faBolt,
  faMicrophone,
  faStop
} from '@fortawesome/free-solid-svg-icons';
import { API_BASE } from 'apiConfig';
import { SENT_MESSAGE } from 'reducers/ChatReducer';

import { useAppContext } from 'providers/AppProvider';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store'; // Import the RootState type from your store
import { useDispatch } from 'react-redux';

import {
  startChat,
  sendTypingMessage,
  sendMessage
} from 'store/slices/trafficSlice';

const ChatContentFooter = ({ currentChatCustomerID }: any) => {
  const customers = useSelector((state: RootState) => state.traffic.customers);
  const token = useSelector((state: RootState) => state.auth.token);
  interface User {
    avatar_url?: string;
    name?: string;
    // add other properties as needed
  }
  const currentUser = useSelector((state: RootState) => state.auth.user) as User | null;

  const license_uuid = useSelector((state: RootState) => state.auth.license_uuid);


  const dispatch = useDispatch();


  const {
    config: { isDark }
  } = useAppContext();

 

  function getCurrentCustomer(customer_id: any) {
    const currentCustomer = customers.find(
      item => item.customer_id === customer_id
    );
    return currentCustomer;
  }

  const currentCustomer = getCurrentCustomer(currentChatCustomerID);
  const loggedinAgent = token;

  const [messageText, setMessageText] = useState('');
  const [fileAttachment, setFileAttachment] = useState<File | null>(null);
  const [imageAttachments, setImageAttachments] = useState<File[]>([]);

  // Saved replies (canned responses) for this account.
  const [canned, setCanned] = useState<
    Array<{ id: string; title: string; shortcut: string; body: string }>
  >([]);
  const [showCanned, setShowCanned] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/canned-responses`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined
    })
      .then(r => (r.ok ? r.json() : { canned: [] }))
      .then(d => setCanned(d.canned || []))
      .catch(() => undefined);
  }, [token]);

  // Filter by the "/" query the agent is typing, else show all (button toggle).
  const cannedQuery = messageText.startsWith('/') ? messageText.slice(1).toLowerCase() : '';
  const cannedMatches = (
    messageText.startsWith('/')
      ? canned.filter(
          c =>
            c.shortcut.toLowerCase().includes(cannedQuery) ||
            c.title.toLowerCase().includes(cannedQuery)
        )
      : canned
  ).slice(0, 6);

  const insertCanned = (c: { body: string }) => {
    setMessageText(c.body);
    setShowCanned(false);
  };

  const sentMessageStartChat = () => {

    console.log("aaaaa ------- 999999999")

    dispatch(
      startChat({
        customerId: currentChatCustomerID,
        message: messageText == '' ? 'Hello, how are you' : messageText,
        ownerToken: license_uuid ? license_uuid : '',
        token: token ? token : "",
        avatar_url: currentUser?.avatar_url ?? "",
        agent_name: currentUser?.name ?? "",
        messageId: generateUniqueId()
      })
    );

    setMessageText('');
    setImageAttachments([]);
    setFileAttachment(null);
  };

  const triggerTypingMessage = () => {
    dispatch(
      sendTypingMessage({
        customerId: currentChatCustomerID,
        ownerToken: token ? token : ''
      })
    );
  };


  function generateUniqueId() {
    return `${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 9)}`;
  }


  const sentMessage = () => {


 


    if (messageText || fileAttachment || imageAttachments.length > 0) {

      dispatch(
        sendMessage({
          messageId: generateUniqueId(),
          customerId: currentChatCustomerID,
          message: messageText,
          ownerToken: token ? token : '',
          license_uuid:  license_uuid ? license_uuid : "",
          avatar_url: currentUser?.avatar_url ?? "",
          agent_name: currentUser?.name ?? ""
        })
      );

      /*  customersDispatch({
        type: trafficActionTypes.SEND_MESSAGE_TO_USER,
        payload: {
          agentToken: loggedinAgent,
          customer_id: currentChatConversation,
          message: messageText,
          attachments: {
            images: imageAttachments.map(imageAttachment =>
              URL.createObjectURL(imageAttachment)
            ),
            file: fileAttachment
              ? convertFileToAttachment(fileAttachment)
              : undefined
          }
        }
      }); */

      setMessageText('');
      setImageAttachments([]);
      setFileAttachment(null);
    }
  };

  const disabled = currentCustomer?.active !== true;
  const onSend = () => {
    if (disabled) return;
    if (currentCustomer?.chat_started) sentMessage();
    else sentMessageStartChat();
  };

  // Upload an image/audio to the backend, then send it as an agent message.
  const uploadAndSend = async (file: File | Blob, duration?: number) => {
    if (disabled) return;
    const fd = new FormData();
    fd.append('file', file);
    if (duration) fd.append('duration', String(Math.round(duration)));
    try {
      const res = await fetch(`${API_BASE}/chat/upload`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: fd
      });
      const d = await res.json();
      if (!res.ok || !d?.url) {
        window.alert(d?.error || 'Upload failed.');
        return;
      }
      dispatch(
        sendMessage({
          messageId: generateUniqueId(),
          customerId: currentChatCustomerID,
          message: '',
          ownerToken: token || '',
          license_uuid: license_uuid || '',
          avatar_url: currentUser?.avatar_url ?? '',
          agent_name: currentUser?.name ?? '',
          attachment: { url: d.url, type: d.type, meta: d.meta || {} }
        })
      );
    } catch {
      window.alert('Upload failed.');
    }
  };

  // ---- agent voice recording (MediaRecorder -> Opus/WebM) ----
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const recChunksRef = useRef<Blob[]>([]);
  const recStartRef = useRef(0);
  const recTimerRef = useRef<any>(null);
  const [recording, setRecording] = useState(false);

  const stopRecording = () => {
    try {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
    } catch {
      /* noop */
    }
  };

  const toggleRecording = () => {
    if (recording) {
      stopRecording();
      return;
    }
    if (disabled) return;
    if (!navigator.mediaDevices?.getUserMedia) {
      window.alert('Recording is not supported in this browser.');
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(stream => {
        recChunksRef.current = [];
        let mr: MediaRecorder;
        try {
          mr = new MediaRecorder(stream);
        } catch {
          window.alert('Recording not supported.');
          return;
        }
        mediaRecorderRef.current = mr;
        recStartRef.current = Date.now();
        mr.ondataavailable = e => {
          if (e.data && e.data.size) recChunksRef.current.push(e.data);
        };
        mr.onstop = () => {
          setRecording(false);
          clearTimeout(recTimerRef.current);
          stream.getTracks().forEach(t => t.stop());
          const dur = (Date.now() - recStartRef.current) / 1000;
          const blob = new Blob(recChunksRef.current, {
            type: recChunksRef.current[0]?.type || 'audio/webm'
          });
          mediaRecorderRef.current = null;
          if (blob.size > 200) uploadAndSend(blob, dur);
        };
        mr.start();
        setRecording(true);
        recTimerRef.current = setTimeout(stopRecording, 120000);
      })
      .catch(() => window.alert('Microphone permission denied.'));
  };

  return (
    <Card.Footer className="border-top p-3">
      {currentCustomer?.customer_typing_text == true &&
      currentCustomer?.customer_typed_text.length > 0 ? (
        <div className="mb-2 fs-9 fst-italic text-body-secondary px-1">
          {(currentCustomer?.name || 'Visitor')} is typing: {currentCustomer?.customer_typed_text} …
        </div>
      ) : null}

      {fileAttachment && (
        <div className="mb-2">
          <AttachmentPreview
            attachment={convertFileToAttachment(fileAttachment)}
            size="xl"
            handleRemove={() => setFileAttachment(null)}
          />
        </div>
      )}

      {imageAttachments.length > 0 && (
        <div className="mb-2 d-flex gap-2">
          {imageAttachments.map((attachment, index) => (
            <ImageAttachmentPreview
              key={index}
              image={URL.createObjectURL(attachment)}
              handleClose={() => {
                setImageAttachments(imageAttachments.filter((_, i) => index !== i));
              }}
            />
          ))}
        </div>
      )}

      <div style={{ position: 'relative' }}>
        {showCanned && cannedMatches.length > 0 && (
          <div
            className="border rounded shadow-sm"
            style={{
              position: 'absolute',
              bottom: 'calc(100% + 6px)',
              left: 0,
              right: 0,
              maxHeight: 240,
              overflowY: 'auto',
              zIndex: 20,
              background: isDark ? '#1f2024' : '#fff'
            }}
          >
            {cannedMatches.map(c => (
              <div
                key={c.id}
                role="button"
                onClick={() => insertCanned(c)}
                className="px-3 py-2 border-bottom canned-item"
                style={{ cursor: 'pointer' }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="fw-semibold fs-9">{c.title}</span>
                  {c.shortcut && (
                    <code className="fs-10 text-body-tertiary">{c.shortcut}</code>
                  )}
                </div>
                <div className="fs-9 text-body-tertiary line-clamp-1">{c.body}</div>
              </div>
            ))}
          </div>
        )}

      <div
        className="d-flex align-items-end gap-2 border"
        style={{
          borderRadius: 20,
          padding: '6px 8px 6px 14px',
          background: isDark ? '#1f2024' : '#f6f7f9'
        }}
      >
        {canned.length > 0 && (
          <Button
            className="p-0 text-body-tertiary fs-8 lh-1"
            onClick={() => setShowCanned(v => !v)}
            aria-label="Saved replies"
            title="Saved replies"
          >
            <FontAwesomeIcon icon={faBolt} />
          </Button>
        )}
        <EmojiPicker
          onSelect={selection => {
            setMessageText(messageText => messageText + selection.emoji);
          }}
        >
          <Button variant="link" className="p-0 text-body-tertiary fs-8 lh-1 btn-emoji">
            <FontAwesomeIcon icon={faFaceSmile} />
          </Button>
        </EmojiPicker>

        <Button className="p-0 text-body-tertiary fs-8 lh-1" title="Send an image">
          <label className="cursor-pointer m-0" htmlFor="images">
            <FontAwesomeIcon icon={faImage} />
          </label>
        </Button>
        <Form.Control
          className="d-none"
          type="file"
          accept="image/*"
          id="images"
          onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
            const f = target.files && target.files[0];
            if (f) uploadAndSend(f);
            target.value = '';
          }}
        />

        <Button
          className="p-0 fs-8 lh-1"
          onClick={toggleRecording}
          disabled={disabled}
          title={recording ? 'Stop recording' : 'Record audio'}
          style={{ color: recording ? '#e5484d' : undefined }}
        >
          <FontAwesomeIcon icon={recording ? faStop : faMicrophone} />
        </Button>

        <Button className="p-0 text-body-tertiary fs-8 lh-1">
          <label className="cursor-pointer m-0" htmlFor="attachments">
            <FontAwesomeIcon icon={faPaperclip} />
          </label>
        </Button>
        <Form.Control
          className="d-none"
          type="file"
          id="attachments"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp,.rtf,.csv,.txt,.zip"
          onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
            const f = target.files && target.files[0];
            if (f) uploadAndSend(f);
            target.value = '';
          }}
        />

        <ReactTextareaAutosize
          minRows={1}
          maxRows={6}
          value={messageText}
          placeholder={
            disabled ? 'Visitor is offline' : 'Type your message…'
          }
          disabled={disabled}
          onChange={({ target: { value } }) => {
            setMessageText(value);
            triggerTypingMessage();
            setShowCanned(value.startsWith('/'));
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
          className="form-control border-0 bg-transparent shadow-none outline-none resize-none scrollbar p-0 fs-8 fw-normal align-self-center"
        />

        <Button
          onClick={onSend}
          disabled={disabled}
          className="btn-icon rounded-circle flex-shrink-0"
          style={{
            width: 36,
            height: 36,
            background: isDark ? '#e8eaed' : '#1b1c20',
            color: isDark ? '#16181d' : '#ffffff',
            opacity: disabled ? 0.5 : 1
          }}
          aria-label={currentCustomer?.chat_started ? 'Send' : 'Start chat'}
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </Button>
      </div>
      </div>
    </Card.Footer>
  );
};

export default ChatContentFooter;
